<!-- Nav Menu -->

<template>
  <div id="app">
    <transition name="fade" appear> <router-view :key="$route.fullPath" :season='season' :config='env'/></transition>
  </div>
</template>

<style>
</style>

<script>

export default {
    components: {
    },
    data(){
        return{
            env:[]
        }
    },
    mounted(){
      this.env=process.env
    }
};
</script>
